import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class Httpservice {
  //base_url="http://127.0.0.1:3333/"
  base_url="https://www.manypaycash.com/"
  constructor(private http:HttpClient){}
  checkToken(token:string){
    let url=this.base_url+'api/checkPaiementToken/'+token
    return this.http.get<CheckTokenTep>(url)
  }
  initPayment(payload:any):Observable<initPayRep>{
    let url=this.base_url+'api/initwebpayment'
    return this.http.post<initPayRep>(url,payload)
  }
  
}
export interface CheckTokenTep{
  code:number;
  token:string;
  montant:number
}
export interface initPayRep{
  code: number, 
  status: string,
   payment_link: string
}
